import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleEmpty12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSpeechBubbleEmpty12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.429 9v1.988L6.327 9.26 6.613 9H10.5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5zM7 10h3.5A1.5 1.5 0 0 0 12 8.5v-6A1.5 1.5 0 0 0 10.5 1h-9A1.5 1.5 0 0 0 0 2.5v6A1.5 1.5 0 0 0 1.5 10h1.929v.988c0 .868 1.03 1.324 1.673.74z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleEmpty12);
